// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"395bfd08","347":"718a82c0"}[chunkId] + ".chunk.js";
};